import type { AgentDeal, User } from '@repo/database/src/types';
import { Prisma } from '@repo/database/src/types';
import { Transform, Type } from 'class-transformer';
import { IsBoolean, IsEnum, IsObject, IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';

import { AgentDealStatus } from '../../agent-deal-status';
import { PaginationOptionsDto } from '../../pagination-options-types';

export class AdminAgentDealsFilterDto {
  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsEnum(['Override', 'Flat'])
  dealType?: 'Override' | 'Flat';

  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => value === true || value === 'true')
  isRegionalManager?: boolean;

  @IsOptional()
  @Transform(({ value }) => {
    if (value === undefined || value === null || value === '') return undefined;
    return Array.isArray(value) ? value : [value];
  })
  @IsEnum(AgentDealStatus, { each: true })
  dealStatus?: AgentDealStatus[];

  @IsOptional()
  @IsUUID('4')
  regionId?: string;
}

export class GetAdminAgentDealsDto extends PaginationOptionsDto {
  @IsObject()
  @ValidateNested()
  @IsOptional()
  @Type(() => AdminAgentDealsFilterDto)
  filter?: AdminAgentDealsFilterDto;

  @IsOptional()
  sorts?: Array<{ field: keyof AgentDeal | string; order: Prisma.SortOrder }>;
}

export interface AdminAgentDealDto
  extends Omit<AgentDeal, 'createdAt' | 'updatedAt' | 'deletedAt' | 'startDate' | 'endDate'> {
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  user?: User;
}

export interface AdminAgentDealsResponseDto {
  items: AdminAgentDealDto[];
  totalCount: number;
  skip: number;
  take: number;
}
